import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDeductions: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 22H3C2.448 22 2 21.552 2 21V17C2 16.448 2.448 16 3 16H5C5.552 16 6 16.448 6 17V21C6 21.552 5.552 22 5 22ZM19.66 16.02C19.43 16.02 19.2 16.08 18.98 16.21L16.71 17.5699C16.5 18.7999 15.42 19.75 14.12 19.75H11C10.59 19.75 10.25 19.41 10.25 19C10.25 18.59 10.59 18.25 11 18.25H14.12C14.74 18.25 15.25 17.75 15.25 17.12C15.25 16.5 14.74 16 14.12 16H9C7.9 16 7 16.9 7 18V20C7 21.1 7.9 22 9 22H14.6C15.51 22 16.39 21.69 17.1 21.12L20.5 18.4C20.82 18.15 21 17.76 21 17.36C21 16.58 20.36 16.02 19.66 16.02Z"
      fill={color}
    />
    <rect x="6" y="3" width="11" height="11" rx="5.5" fill="white" />
    <path
      d="M11.4995 2.9996C8.4744 2.9996 5.99951 5.47449 5.99951 8.4996C5.99951 11.5247 8.4744 13.9996 11.4995 13.9996C14.5246 13.9996 16.9995 11.5247 16.9995 8.4996C16.9995 5.47449 14.5246 2.9996 11.4995 2.9996ZM12.4889 8.63045V8.94678C12.4889 9.07971 12.3812 9.18751 12.2482 9.18751H11.1146V10.673H13.3209C13.4538 10.673 13.5616 10.7807 13.5616 10.9136V11.2841C13.5616 11.417 13.4539 11.5247 13.3209 11.5247H9.70443C9.64061 11.5247 9.57941 11.4994 9.53429 11.4542C9.48917 11.4091 9.46382 11.3479 9.46382 11.2841V10.9136C9.46382 10.7807 9.5715 10.673 9.70443 10.673H10.1238V9.18739H9.65024C9.61863 9.18741 9.58733 9.1812 9.55813 9.16911C9.52892 9.15703 9.50238 9.1393 9.48003 9.11696C9.45767 9.09462 9.43994 9.06809 9.42784 9.03889C9.41574 9.00969 9.40951 8.97839 9.40951 8.94678V8.63045C9.40951 8.49752 9.5172 8.38983 9.65024 8.38983H10.1238V7.37262C10.1238 6.71262 10.2892 6.21647 10.6199 5.91495C11.2436 5.34249 12.6529 5.16325 13.4323 6.19007C13.5101 6.29277 13.4889 6.44017 13.3883 6.52088L13.0683 6.77735C12.9706 6.85562 12.8261 6.84868 12.7433 6.75477C12.1493 6.0818 11.0868 6.29752 11.0868 7.31705V8.38983H12.2482C12.3811 8.38983 12.4889 8.49752 12.4889 8.63045Z"
      fill={color}
    />
  </svg>
);

export default IconDeductions;
